import {
  AUDIOMACK_ERROR_CODES,
  ArtistPortalConnectFailure,
  ArtistPortalConnectResult,
  artistPortalConnectReturnParams,
} from 'fym-shared/src/smartlinks/artistPortals';
import { SOUNDCLOUD_ERROR_CODES } from 'fym-shared/src/music24/songPublish';

/** Why `auth/complete` of a return-page sign-in failed, as a reason the Catalog screen knows. */
export function portalReturnFailure(error: unknown): ArtistPortalConnectFailure {
  const record = error as { m24Limit?: { code?: unknown }; statusCode?: unknown } | null;
  const code = record?.m24Limit?.code;
  if (code === SOUNDCLOUD_ERROR_CODES.connectStateInvalid) {
    return ArtistPortalConnectFailure.invalidState;
  }
  if (code === AUDIOMACK_ERROR_CODES.loginInUse) {
    return ArtistPortalConnectFailure.loginInUse;
  }
  return record?.statusCode === 400 ? ArtistPortalConnectFailure.exchangeFailed : ArtistPortalConnectFailure.unknown;
}

/**
 * The Catalog address that shows the outcome (`usePortalConnectReturn` reads it): connected,
 * pick an artist, or an error with its reason. Relative to the router basename (`/app`).
 */
export function portalReturnTarget(params: {
  accountId: number;
  integrationType: string;
  result: ArtistPortalConnectResult;
  reason?: ArtistPortalConnectFailure;
}): string {
  const query = new URLSearchParams({
    accountId: String(params.accountId),
    [artistPortalConnectReturnParams.service]: params.integrationType,
    [artistPortalConnectReturnParams.result]: params.result,
  });
  if (params.result === ArtistPortalConnectResult.error && params.reason !== undefined) {
    query.set(artistPortalConnectReturnParams.reason, params.reason);
  }
  return `/catalog?${query.toString()}`;
}
